import { App_Url_New, EMAIL_TEMPLATE_KEYS } from "@/shared/common/static";
import { Button } from "@/shared/components";
import { axiosInstance } from "@/shared/lib/axiosInstance";
import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { getAuthSessionIdentifiers } from "@/shared/utils/authSession";
import { Mail } from "lucide-react";
import { showToast } from "../lib/toast";

type SendQuoteEmailButtonProps = {
  email: string;
  fullName: string;
  activeStep: number;
  uploadLink: string;
  apiEndpoint?: string;
  templateKey?: string;
  disabled?: boolean;
};

export function SendQuoteEmailButton({
  email,
  fullName,
  activeStep,
  uploadLink,
  apiEndpoint = App_Url_New.ApiEndPoint.newQuoteEmailSend,
  templateKey = EMAIL_TEMPLATE_KEYS.GET_QUOTE_EMAIL,
  disabled = false,
}: SendQuoteEmailButtonProps) {
  const {
    auth: { session: authSession },
  } = usePosterReducers();
  const { clientId } = getAuthSessionIdentifiers(authSession);

  const sendEmail = async () => {
    if (disabled) {
      return;
    }

    if (!email) {
      showToast("Cannot send quote email: Customer email is missing.", "error");
      return;
    }

    try {
      const payload = {
        template_key: templateKey,
        email,
        channels: [
          {
            type: "email",
            provider: "azure",
            enabled: true,
          },
        ],
        payload: {
          customer_name: fullName,
          client_id: clientId ? Number(clientId) : null,
          step: String(activeStep + 1),
          upload_link: uploadLink,
        },
      };

      const response = await axiosInstance.post(apiEndpoint, payload);
      if (response.status === 200) {
        showToast("Quote email sent successfully!", "success");
      } else {
        showToast("Failed to send quote email!", "error");
      }
      console.log("Email sent response:", response);
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };

  return (
    <Button
      onClick={sendEmail}
      disabled={disabled}
      className="group w-full max-w-sm rounded-xl border-2 border-theme-primary bg-white !text-theme-primary hover:!text-white gap-2 h-11"
    >
      <Mail className="w-5 h-5 text-theme-primary transition-colors group-hover:text-white" />
      Send Quote to Email
    </Button>
  );
}
